import React from 'react';
import { TackShape } from '../shapes';
import { Link } from 'react-router-dom';
import DateMaster from '../stores/utils/date_master';

export default class QueuedUserTack extends React.Component {

  static propTypes = {
    tack: TackShape
  }

  render() {
    return(
      <div className='user-tack'>
        <Link to={ `/words/${ this.props.tack.get('wordText') }/${ this.props.tack.get('language') }` }>
          <h4 className='word-title'>{ this.props.tack.get('wordText') }</h4>
        </Link>
        <ul className='item-meta'>
          <li>
            <b>Queued On</b>: { DateMaster.format(this.props.tack.get('createdAt')) }
          </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/queued_user_tack.jsx